import React, { useState } from 'react';
import { Dialog, DialogContent, DialogActions, Button, CircularProgress, Typography, Box } from '@mui/material';
import { Warning, ErrorOutline } from '@mui/icons-material';

const FormSubmissionHandler = ({ isSubmitting, onRetry, onClose, error }) => {
  const [showTimeout, setShowTimeout] = useState(false);
  const TIMEOUT_DURATION = 60000; // 60 seconds timeout

  React.useEffect(() => {
    let timeoutId;
    
    if (isSubmitting) {
      timeoutId = setTimeout(() => {
        setShowTimeout(true);
      }, TIMEOUT_DURATION);
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [isSubmitting]);

  if (!isSubmitting && !error && !showTimeout) return null;

  return (
    <Dialog 
      open={true} 
      onClose={onClose}
      fullWidth
      maxWidth="xs"
    >
      <DialogContent>
        <Box 
          display="flex" 
          flexDirection="column" 
          alignItems="center" 
          py={2}
        >
          {isSubmitting && !showTimeout && (
            <>
              <CircularProgress size={48} color="primary" />
              <Typography variant="h6" sx={{ mt: 2 }}>
                Submitting Request...
              </Typography>
              <Typography variant="body2" color="textSecondary" align="center">
                Please wait while we process your request
              </Typography>
            </>
          )}

          {showTimeout && (
            <>
              <Warning sx={{ fontSize: 48, color: 'warning.main' }} />
              <Typography variant="h6" sx={{ mt: 2 }}>
                Taking longer than expected
              </Typography>
              <Typography variant="body2" color="textSecondary" align="center">
                Would you like to retry or continue waiting?
              </Typography>
            </>
          )}

          {error && (
            <>
              <ErrorOutline sx={{ fontSize: 48, color: 'error.main' }} />
              <Typography variant="h6" sx={{ mt: 2 }}>
                Submission Failed
              </Typography>
              <Typography variant="body2" color="textSecondary" align="center">
                {error}
              </Typography>
            </>
          )}
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3 }}>
        {showTimeout && (
          <>
            <Button 
              variant="outlined"
              onClick={onRetry}
              fullWidth
            >
              Retry
            </Button>
            <Button
              variant="contained"
              onClick={() => setShowTimeout(false)}
              fullWidth
            >
              Keep Waiting
            </Button>
          </>
        )}

        {error && (
          <>
            <Button
              variant="outlined"
              onClick={onClose}
              fullWidth
            >
              Cancel
            </Button>
            <Button 
              variant="contained"
              onClick={onRetry}
              fullWidth
            >
              Try Again
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default FormSubmissionHandler;